import { defineComponent as _defineComponent } from 'vue'
import { onBeforeUnmount, ref, computed, onMounted } from 'vue';
import i18n from '@/plugins/i18n';
import {TranslateResult} from 'vue-i18n'
import store from "@/bootstrap/store";
import {bus} from '@/bootstrap/bus'
import outboundApiGateway from "@/api/outboundApiGateway";
import NotificationTypes from '@/enums/NotificationTypes';
import { useCarriersStore } from '@/stores/carriers';
import DispatchConfirmationModal from './DispatchConfirmationModal.vue';
import ScannedContainersList from "@/components/pages/Outbound/ScannedContainersList.vue";
import { getPackageContainer } from "@/utilities/CodeIdentifier";

export type ScannedContainer = {
  id: number;
  name: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DispatchContainers',
  setup(__props) {

const vuexStore = store;
const carrierStore = useCarriersStore();

const carriers = computed(() => {
  return carrierStore.carriers.map(carrier => ({
    text: carrier.attributes.name,
    value: carrier.id
  }))
})

const siteId = vuexStore.getters["core/getAuthUser"].site_id;

const error = ref<TranslateResult | null>(null);
const selectedCourier = ref<string>('');
const courierReference = ref<string>('');
const loadingCouriers = ref<boolean>(false);
const scannedContainers = ref<ScannedContainer[]>([]);
const showConfirmationModal = ref<boolean>(false);

bus.$on("barcodeScanned", handleItemScan);

async function getCarriers(){
  const carriers = await outboundApiGateway.getCarrierList(siteId);
  carrierStore.setCarriers(carriers)
}

onMounted(async () => {
  await getCarriers()
})

onBeforeUnmount(() => {
  bus.$off("barcodeScanned", handleItemScan);
})

const canDispatchContainers = computed(() => {
  if(!selectedCourier.value || scannedContainers.value.length === 0 || !courierReference.value.trim()) {
    return false;
  }
  return true;
})

const openConfirmationModal = ():void => {
  if(canDispatchContainers) {
    showConfirmationModal.value = true;
  }
}

const closeConfirmationModal = ():void => {
  showConfirmationModal.value = false;
}

function submitAndCloseConfirmationModal(): void {
  dispatchContainers()
  closeConfirmationModal();
  reset();
}

const dispatchContainers = ():void => {
  if(canDispatchContainers) {
    outboundApiGateway
      .dispatchToCarrier(
        scannedContainers.value.map((container: ScannedContainer) => container.id),
        selectedCourier.value,
        courierReference.value
      ).then(() => {
        store.dispatch("core/addNotification", {
          message: i18n.t('outbound.containers_dispatched_successfully'),
          type: NotificationTypes.NOTIFICATION_TYPE_SUCCESS,
          timeout: 1000,
        });
      })
  }
}



function reset(): void {
  error.value = null
  selectedCourier.value = ''
  courierReference.value = ''
  scannedContainers.value = []
}

const removeScannedContainer = (id: number): void  => {
  if(scannedContainers.value.length === 0) {
    return
  }
  scannedContainers.value = scannedContainers.value.filter((container: ScannedContainer) => container.id !== id)
}

function handleItemScan (scanResult: string): void {
  error.value = null;
  let isRecognisedContainer = false;

  const labelId = getPackageContainer(scanResult)

  if (!labelId) {
    error.value = i18n.t('outbound.unrecognised_container');
    return;
  }

  //check this is not a duplicate
  const containerIndex = scannedContainers.value.findIndex((container: ScannedContainer) => container.id === Number(labelId));
  if (containerIndex >= 0) {
    error.value = i18n.t('outbound.duplicate_container');
    return;
  }

  // @todo: check database if this is a valid container to dispatch!
  isRecognisedContainer = true;
  if (!isRecognisedContainer) {
    error.value = i18n.t('outbound.unrecognised_container');
    return;
  }

  scannedContainers.value.push({
    id: Number(labelId),
    name: `PC${labelId}`,
  });
}


return { __sfc: true,vuexStore, carrierStore, carriers, siteId, error, selectedCourier, courierReference, loadingCouriers, scannedContainers, showConfirmationModal, getCarriers, canDispatchContainers, openConfirmationModal, closeConfirmationModal, submitAndCloseConfirmationModal, dispatchContainers, reset, removeScannedContainer, handleItemScan, DispatchConfirmationModal, ScannedContainersList }
}

})